/* eslint-disable max-len */
import { Component, Inject, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from 'src/app/services/auth.service';
import firebase from 'firebase/app';
import 'firebase/firestore';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent implements OnInit {
  chats: any = [];
  unsub1;
  unsub2;
  connections = [];
  currentUser;
  constructor(
    public navController: NavController,
    public modalController: ModalController,
    public authService: AuthService,
    public modalCtrl: ModalController,
    public firestore: AngularFirestore

  ) {

  };

  ngOnInit() {
    this.unsub2 = this.authService.currentAccount.subscribe(async (currentUser) => {
      this.currentUser = currentUser;
      this.getChats(this.currentUser);
      this.getConnections();
    });
  }

  async getConnections() {
    this.connections = [];
    const q = this.firestore.collection('connections', ref => ref.where('users', 'array-contains', this.currentUser?.id));
    const documentSnapshots = await q.get().toPromise();
    documentSnapshots.forEach(async (docRef) => {
      const data: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
      if (data.status === 'accepted') {
        const friendId = data.requestedTo === this.currentUser?.id ? data.requestedBy : data.requestedTo;
        data.friend = await this.authService.getUserById(friendId);
        this.connections.push(data);
      }
    });
    return this.connections;
  }

  getChats(currentUser: any) {
    console.log('currentUser', this.currentUser);
    // eslint-disable-next-line max-len
    const q = this.firestore.collection('chats', ref => ref.where('users', 'array-contains', currentUser?.id));
    this.unsub1 = q.snapshotChanges().subscribe(async (snapshot) => {
      snapshot.forEach(async (change) => {
        if (change.type === 'added') {
          console.log('New chats: ', change.payload.doc.data());
          const chat: any = change.payload.doc.data();
          chat.id = change.payload.doc.id;
          if (chat.users) {
            chat.friend = await this.authService.getUserById(chat.users.find(user => user !== currentUser?.id));
          }
          this.chats = [...this.chats, chat];
          console.log(this.chats);

        }
        if (change.type === 'modified') {
          console.log('Modified chats: ', change.payload.doc.data());
          const chat: any = change.payload.doc.data();
          chat.id = change.payload.doc.id;
          if (chat.users) {
            chat.friend = await this.authService.getUserById(chat.users.find(user => user !== currentUser?.id));
          }
          const index = this.chats.findIndex(chat1 => chat1.id === chat.id);
          if (index >= 0) {
            this.chats[index] = chat;
          }
        }
        if (change.type === 'removed') {
          console.log('Removed chats: ', change.payload.doc.data());
          const chat: any = change.payload.doc.data();
          chat.id = change.payload.doc.id;
          this.chats = this.chats.filter((chat1) => chat1.id !== chat.id);
          console.log(this.chats);
        }
      });
    });
  }

  openChat(chat: any) {
    this.navController.navigateRoot(['/message', chat.id]);
    this.modalController.dismiss();
  }

  openProfile(user: any) {
    this.navController.navigateRoot(['/profile', user.uid]);
    this.modalController.dismiss();
  }


  async createChat(user: any) {
    console.log('user', user);
    const userId = user.id;
    console.log('userId', userId);
    const chat = this.chats.find(chat1 => chat1.users && chat1.users.includes(userId));
    console.log(chat);
    if (!chat) {
      const docRef = await this.firestore.collection('chats').add({
        users: [this.currentUser.id, userId],
        messages: [],
        createdAt: new Date(),
      });
      console.log('==>>>', docRef.id);
      const docRef2 = this.firestore.collection('accounts').doc(this.currentUser.id);
      // Atomically add a new region to the "regions" array field.
      docRef2.update({ chats: firebase.firestore.FieldValue.arrayUnion(docRef.id) }).then(() => {
        this.openChat({ id: docRef.id });
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  deleteChat(item: any) {
    console.log(item.id);
    const docRef2 = this.firestore.collection('accounts').doc(this.currentUser.id);
    // Atomically add a new region to the "regions" array field.
    docRef2.update({ chats: firebase.firestore.FieldValue.arrayRemove(item.id) }).then(() => {
      this.firestore.collection('chats').doc(item.id).delete();
    }).catch((error) => {
      console.log(error);
    });
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  ionviewDidLeave() {
    if (this.unsub1) {this.unsub1.unsubscribe();}
    if (this.unsub2) {this.unsub2.unsubscribe();}
  }

}
